import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import addEmperor from "../banUser/components/add.vue";
import add from "./components/add";
import { abnormalList, unbanUser, abnormalListAll } from "@/api/gmToolNew/gmToolNew";
import { gmToolNew, gmToolNewPage } from "@/mixins/index";
import { mapState, mapActions } from 'vuex';
export default {
  name: "abnormalUser",
  mixins: [gmToolNew, gmToolNewPage],
  components: {
    addEmperor: addEmperor,
    add: add
  },
  data: function data() {
    return {
      advanced: false,
      tableData: [],
      paramsData: {
        uid: '',
        uname: '',
        start_time: '',
        end_time: '',
        page: 1,
        status: ''
      },
      popData: {
        server_id: ''
      },
      date: [],
      total: 0,
      exportdataDealoading: false,
      isAbnormakList: [{
        label: this.$t('notPunished'),
        value: 1
      }, {
        label: this.$t('banned'),
        value: 2
      }, {
        label: this.$t('banEnded'),
        value: 3
      }, {
        label: this.$t('unbanned'),
        value: 4
      }]
    };
  },
  created: function created() {
    var end = new Date(new Date().setHours(23, 59, 59, 0));
    var start = new Date();
    start.setDate(start.getDate() - 7);
    start.setHours(0, 0, 0, 0);
    this.date = [start, end];
  },
  computed: _objectSpread({}, mapState("d2admin", {
    rawData: function rawData(state) {
      return state.serchSelect.rawData;
    }
  })),
  methods: {
    getList: function getList(e) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.paramsData.server_id.length == 0)) {
                  _context.next = 3;
                  break;
                }

                _this.$message.error(_this.$t('pleaseSelectServer'));

                return _context.abrupt("return");

              case 3:
                _this.paramsData.page = e;
                _this.paramsData.start_time = _this.date && _this.date[0] ? _this.$times.timestampToTime(_this.date[0] / 1000, "YY-MM-DD hh:mm:ss") : '';
                _this.paramsData.end_time = _this.date && _this.date[1] ? _this.$times.timestampToTime(_this.date[1] / 1000, "YY-MM-DD hh:mm:ss") : '';
                _this.reqLoading = true;
                _this.paramsData.game = _this.rawData.game_mark;
                abnormalList(_this.paramsData).then(function (res) {
                  if (res.code == 200) {
                    var date = Math.abs(new Date(_this.$times.zeroTimeZone()).getTime() / 1000);
                    res.data.data.map(function (item) {
                      item.status = '';

                      if (item.op_type === 0) {
                        item.status = item.expire_time > 0 ? '4' : '1';
                      } else {
                        item.status = item.expire_time > date ? '2' : '3';
                      }

                      item.html = '';
                      item.ban_state.map(function (j) {
                        j.timenew = j.time;
                        j.expire_timenew = j.expire_time;
                        j.finishs = j.expire_time > Date.parse(new Date()) / 1000 ? true : false;
                        item.html = item.html + "".concat(_this.$t('operationTime'), ":").concat(j.timenew, ", ").concat(_this.$t('banEndTime'), ":").concat(j.expire_timenew, ", ").concat(_this.$t('reason')).concat(j.reason, " <br/>");
                      });
                    });
                    _this.tableData = res.data.data;
                    _this.total = res.data.total;
                  }
                }).finally(function () {
                  _this.reqLoading = false;
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    deleHandle: function deleHandle(row) {
      this.$refs.add.open(row);
    },
    exportdata: function exportdata() {
      var _this2 = this;

      this.exportdataDealoading = true;
      this.paramsData.start_time = this.date && this.date[0] ? this.$times.timestampToTime(this.date[0] / 1000, "YY-MM-DD hh:mm:ss") : '';
      this.paramsData.end_time = this.date && this.date[1] ? this.$times.timestampToTime(this.date[1] / 1000, "YY-MM-DD hh:mm:ss") : '';
      var data = [];
      abnormalListAll(this.paramsData).then(function (res) {
        if (res.code == 200) {
          var date = Math.abs(new Date(_this2.$times.zeroTimeZone()).getTime() / 1000);
          res.data.map(function (item) {
            item.status = '';

            if (item.op_type === 0) {
              item.status = item.expire_time > 0 ? '4' : '1';
            } else {
              item.status = item.expire_time > date ? '2' : '3';
            }
          });
          data = res.data;
          var columns = [{
            label: _this2.$t('playerId'),
            prop: 'uid'
          }, {
            label: _this2.$t('playerName'),
            prop: 'uname'
          }, {
            label: _this2.$t('totalRechargeAmount'),
            prop: 'recharge_amount'
          }, {
            label: _this2.$t('registerTime'),
            prop: 'register_time'
          }, {
            label: _this2.$t('violationTime'),
            prop: 'time'
          }, {
            label: _this2.$t('violationReason'),
            prop: 'reason'
          }, {
            label: _this2.$t('abnormalCount'),
            prop: 'abnormal_count'
          }, {
            label: _this2.$t('status'),
            prop: 'status'
          }];
          data.map(function (i) {
            i.recharge_amount = (i.recharge_amount / 100).toFixed(2);
            i.register_time = i.register ? i.register.register_time ? i.register.register_time : '/' : '/';
            i.status = i.status == 1 ? _this2.$t('notPunished') : i.status == 2 ? "".concat(_this2.$t('banned'), " - ").concat(i.expire_time) : i.status == 3 ? "".concat(_this2.$t('banEnded'), " - ").concat(i.expire_time) : "".concat(_this2.$t('unbanned'), " - ").concat(i.expire_time);
          });

          _this2.$export.excel({
            columns: columns,
            data: data,
            title: _this2.$route.meta.title
          });
        }
      }).finally(function () {
        _this2.exportdataDealoading = false;
      });
    },
    goToUserDetail: function goToUserDetail(id) {
      this.$router.replace({
        name: 'playerDetails_yujian',
        params: {
          id: id,
          env_id: this.paramsData.env_id,
          server_channel: this.server_channel,
          show_test: this.show_test,
          server_id: this.paramsData.server_id
        }
      });
    }
  }
};